// extracted by mini-css-extract-plugin
export default {"container":"RideDetails_container__Y3YUh","item":"RideDetails_item__2dtwV","value":"RideDetails_value__dpbR4","label":"RideDetails_label__yTwGS"};